<template>
  <div class="item-wrapper" v-if="info && info.name">
    <div class="item-extra-mobile">
      <div class="item-tags" v-if="selectedColor.brands_logo || selectedColor.designer_logo || info.product_label || calcIsShowCustomerTag">
        <img class="logo" v-if="selectedColor.brands_logo" :src="selectedColor.brands_logo">
        <img class="logo designer-logo" v-if="selectedColor.designer_logo" :src="selectedColor.designer_logo">
        <div class="item-tag" v-if="info.product_label && typeof info.product_label === 'string'">
          {{ info.product_label }}
        </div>
        <template v-else-if="Array.isArray(info.product_label)">
          <div v-for="(label, index) in info.product_label" :key="index" class="item-tag">
            {{ label }}
          </div>
        </template>
        <template v-if="Array.isArray(info.custom_tags) && calcIsShowCustomerTag && info.custom_tags">
          <div v-for="(label, index) in info.custom_tags" :key="'custom' + index" class="item-tag custom-tags">
            {{ label }}
          </div>
        </template>
      </div>
      <h1 class="pdp-item-name">
        <span class="star-style" v-if="info.same_star == 1">【明星同款】</span>
        {{ info.name }}
      </h1>
      <div class="pdp-item-extra">
        <div class="pdp-item-classification">
          {{ info.gender.name }} / {{ info.category.name }}
        </div>
        <div class="pdp-item-number">
          <span>货号:{{ selectedColor.style }}</span>
          <img class="icon-copy" @click="copyLabel(selectedColor.style)" src="@/assets/imgs/icons/copy.svg" alt="" />
        </div>
        <template v-if="scope != 'detail'">
          <div class="pdp-item-view">
            <router-link class="pdp-item-link" :to="`/detail/${info.id}-${selectedColor.id}`">查看更多信息</router-link>
          </div>
        </template>
        <template v-if="isShowOriginalPrice(selectedSize || selectedColor)">
          <div class="pdp-item-price has-original_price">
            <span>
              <span class="rmb-symbol">￥{{ (selectedSize || selectedColor).price }}</span>
            </span>
            <span class="pdp-original_price">
              <span class="rmb-symbol">￥{{ (selectedSize || selectedColor).original_price }}</span>
            </span>
          </div>
        </template>
        <template v-else>
          <div class="pdp-item-price">
            <span class="rmb-symbol">￥</span>{{ (selectedSize || selectedColor).price }}
          </div>
        </template>
      </div>
    </div>
    <div class="item-images">
      <div class="pdp-image-swiper" v-if="info.images && info.images.length">
        <!-- <i :class="['iconfont', xSwiper.isBeginning ? 'disabled' : 'enabled']" @click="toSlider(-1)">&#xe615;</i> -->
        <div class="pdp-image-swiper-wrapper">
          <swiper class="swiper-x-container" :options="swiperOption" ref="xSwiper">
            <swiper-slide class="swiper-x-item" v-for="(item, index) in info.images" :key="index">
              <img-hover-zoom :img-def="item" :img-zoom="item" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <i class="iconfont icon-left-arrow" slot="button-prev">&#xe615;</i>
            <i class="iconfont icon-right-arrow" slot="button-next">&#xe628;</i>
          </swiper>
        </div>
        <!-- <i :class="['iconfont', xSwiper.isEnd ? 'disabled' : 'enabled']" @click="toSlider(+1)">&#xe628;</i> -->
      </div>
      <div class="pdp-image-thumbnail" v-if="info.images && info.images.length">
        <ul>
          <li v-for="(item, i) in info.images" :key="i">
            <a :class="[i == xSwiper.activeIndex ? 'active' : '']" @click="goSlider(i)">
              <img :src="item" />
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="item-detail">
      <div class="item-tags" v-if="selectedColor.brands_logo || selectedColor.designer_logo || info.product_label || calcIsShowCustomerTag">
        <img class="logo" v-if="selectedColor.brands_logo" :src="selectedColor.brands_logo">
        <img class="logo designer-logo" v-if="selectedColor.designer_logo" :src="selectedColor.designer_logo">
        <div class="item-tag" v-if="info.product_label && typeof info.product_label === 'string'">
          {{ info.product_label }}
        </div>
        <template v-else-if="Array.isArray(info.product_label)">
          <div v-for="(label, index) in info.product_label" :key="index" class="item-tag">
            {{ label }}
          </div>
        </template>
        <template v-if="Array.isArray(info.custom_tags) && calcIsShowCustomerTag && info.custom_tags">
          <div v-for="(label, index) in info.custom_tags" :key="'custom' + index" class="item-tag custom-tags">
            {{ label }}
          </div>
        </template>
      </div>
      <h1 class="pdp-item-name">
        <span class="star-style" v-if="info.same_star == 1">【明星同款】</span>{{ info.name }}
      </h1>
      <div class="pdp-item-extra">
        <div class="pdp-item-classification">
          {{ info.gender.name }} / {{ info.category.name }}
        </div>
        <div class="pdp-item-number">
          <span>货号:{{ selectedColor.style }}</span>
          <img class="icon-copy" @click="copyLabel(selectedColor.style)" src="@/assets/imgs/icons/copy.svg" alt="" />
        </div>
        <template v-if="scope != 'detail'">
          <div class="pdp-item-view">
            <router-link class="pdp-item-link" :to="`/detail/${info.id}-${selectedColor.id}`">查看更多信息</router-link>
          </div>
        </template>
        <template v-if="isShowOriginalPrice(selectedSize || selectedColor)">
          <div class="pdp-item-price has-original_price">
            <span>
              <span class="rmb-symbol">￥{{ (selectedSize || selectedColor).price }}</span>
            </span>
            <span class="pdp-original_price">
              <span class="rmb-symbol">￥{{ (selectedSize || selectedColor).original_price }}</span>
            </span>
          </div>
        </template>
        <template v-else>
          <div class="pdp-item-price">
            <span class="rmb-symbol">￥</span>{{ (selectedSize || selectedColor).price }}
          </div>
        </template>
      </div>
      <div class="pdp-item-skus">
        <ul class="pdp-item-sku-options">
          <!-- 颜色 -->
          <li class="pdp-item-sku-option" v-if="info.colors && info.colors.length">
            <h2 class="pdp-item-sku-header">
              颜色:
              <span class="pdp-item-sku-colors" v-if="selectedColor">{{
                selectedColor.name
              }}</span>
            </h2>
            <ul class="pdp-item-sku-color-list">
              <li :class="[
                'pdp-item-sku-color-item',
                selectedColor.id == color.id ? 'active' : '',
                color.stock > 0 ? '' : 'disabled',
              ]" v-for="(color, i) in info.colors" :key="i" @click="setColor(color)">
                <img :src="color.cover" :alt="color.name" :title="color.name" />
              </li>
            </ul>
          </li>
          <!-- 尺寸 -->
          <li class="pdp-item-sku-option pdp-item-sku-option-size" v-if="info.sizes && info.sizes.length">
            <h2 class="pdp-item-sku-header">
              尺寸:
              <span class="pdp-item-sku-colors">{{ selectedSize.name }}</span>
              <router-link to="/size-guide" target="_blank" class="pdp-size-guide">尺码表</router-link>
            </h2>
            <ul class="pdp-item-sku-size-list">
              <li class="pdp-item-sku-size-item" v-for="(size, i) in info.sizes" @click="setSize(size)" :key="i">
                <a :class="[
                  selectedSize.id == size.id ? 'active' : '',
                  size.stock > 0 ? '' : 'disabled',
                ]">{{ size.name }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="pdp-item-cart">
        <a class="pdp-item-notify" @click="notify">
          <img class="icon-notify" src="@/assets/imgs/icons/notify.svg" alt="">
          <span>到货通知</span>
        </a>
        <div :class="['pdp-item-stock', selectedSize.id ? '' : 'invalid']">
          可用性:
          {{
            selectedSize.id
              ? selectedSize.stock > 0
                ? "在售"
                : "缺货"
              : "请选择尺码"
          }}
        </div>
        <label class="pdp-item-quantity-label" for="Quantity">
          <span>数量:</span>
          <span v-if="isColorLimitNumber" class='limit-text'>(同款限购{{ colorLimit }}件)</span>
        </label>
        <div class="pdp-item-cart-box">
          <div class="pdp-item-quantity-wrapper">
            <select name="Quantity" id="Quantity" v-model="quantity" @change="changeQuantity">
              <option v-for="i in itemCounterMax" :key="`ViewItemInfo-${info.id}-Quantity-${i}`" :value="i">
                {{ i }}
              </option>
            </select>
          </div>
          <template v-if="!isGoodsColorDisabled(info.id, selectedColor.id)">
            <template v-if="scope == 'detail'">
              <button class="pdp-item-cart-add" :disabled="selectedSize.stock < 1" @click="buyNow">
                立即购买
              </button>
            </template>
            <button class="pdp-item-cart-add" :disabled="selectedSize.stock < 1" @click="confirm">
              {{ confirmText }}
            </button>
          </template>
        </div>
      </div>
      <div class="pdp-item-listing-date" v-if="info.online_season">
        <span>上市日期：</span>
        <span>{{ info.online_season }}</span>
      </div>
      <div class="pdp-item-help-link">
        <h3>全场任意消费可享免费配送服务</h3>
        <!-- <a class="pdp-item-help-tips  udesk-go-service">联系客服</a> -->
      </div>
      <!-- 隐藏评论 -->
      <div class="comment__wrap" v-if="false">
        <div class="comment__header" @click="showComments = !showComments">
          <span class="comment__title">评论（{{ comments.length || 0 }}）</span>
          <i class="iconfont">{{ showComments ? "&#xe613;" : "&#xe61e;" }}</i>
        </div>
        <div class="comment__list" v-if="showComments">
          <VueScroll>
            <!-- 可评论：已登录 + 已购买 + 未评论 -->
            <template v-if="info.allowComments">
              <div class="comment__item comment__insert">
                <div class="comment__info">
                  <div class="comment__field">
                    <span class="comment__field--name">推荐指数</span>
                    <span class="comment__field--stars">
                      <template v-for="i in 5">
                        <i class="iconfont star" :key="`PDP-CMT-NI-PR-${i}`" @click="setRating('productRating', i)"
                          v-if="i <= comment.productRating">&#xe6a3;</i>
                        <i class="iconfont star" :key="`PDP-CMT-NI-PR-${i}`" @click="setRating('productRating', i)"
                          v-else>&#xe6a4;</i>
                      </template>
                    </span>
                  </div>
                  <div class="comment__field">
                    <span class="comment__field--name">物流服务</span>
                    <span class="comment__field--stars">
                      <template v-for="i in 5">
                        <i class="iconfont star" :key="`PDP-CMT-NI-LR-${i}`" @click="setRating('logisticsRating', i)"
                          v-if="i <= comment.logisticsRating">&#xe6a3;</i>
                        <i class="iconfont star" :key="`PDP-CMT-NI-LR-${i}`" @click="setRating('logisticsRating', i)"
                          v-else>&#xe6a4;</i>
                      </template>
                    </span>
                  </div>
                </div>
                <div class="comment__action">
                  <button @click="addComment">提交</button>
                </div>
              </div>
            </template>
            <!-- 有评论 -->
            <template v-if="Array.isArray(comments) && comments.length">
              <div class="comment__item" v-for="(comment, index) in comments" :key="`PDP-Comment-Item-${index}`">
                <div class="comment__author">{{ comment.username }}</div>
                <div class="comment__info">
                  <div class="comment__field">
                    <span class="comment__field--name">推荐指数</span>
                    <span class="comment__field--stars">
                      <template v-for="i in 5">
                        <i class="iconfont star" :key="`PDP-CMT-OI-PR-${index}-${i}`"
                          v-if="i <= comment.productRating">&#xe6a3;</i>
                        <i class="iconfont star" :key="`PDP-CMT-OI-PR-${index}-${i}`" v-else>&#xe6a4;</i>
                      </template>
                    </span>
                  </div>
                  <div class="comment__field">
                    <span class="comment__field--name">物流服务</span>
                    <span class="comment__field--stars">
                      <template v-for="i in 5">
                        <i class="iconfont star" :key="`PDP-CMT-OI-LR-${index}-${i}`"
                          v-if="i <= comment.logisticsRating">&#xe6a3;</i>
                        <i class="iconfont star" :key="`PDP-CMT-OI-LR-${index}-${i}`" v-else>&#xe6a4;</i>
                      </template>
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <!-- 空状态：未登录 + 无评论 -->
            <template v-if="!info.allowComments &&
              (!Array.isArray(comments) || !comments.length)
            ">
              <div class="comment__empty__msg">暂无评论</div>
            </template>
          </VueScroll>
        </div>
      </div>
      <!-- 商品详情 品牌服务 -->
      <el-tabs v-model="detailTab" class="pdp-item-tabs">
        <el-tab-pane label="商品详情" name="mp_description"
          v-if="selectedColor.mp_description && Array.isArray(selectedColor.mp_description)">
          <div v-for="(item, index) in selectedColor.mp_description" :key="index" class='detail-ul-item' v-html="item">
          </div>
        </el-tab-pane>
        <el-tab-pane label="品牌服务" name="brand_service">
          <div v-for="(item, index) in detailBrandService" :key="index" class='detail-ul-item'>
            {{ item }}</div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import ImgHoverZoom from "@/components/ImgHoverZoom.vue";
import "vuescroll/dist/vuescroll.css";
import VueScroll from "vuescroll/dist/vuescroll-native";
import types from "@/store/types";
import api from "@/utils/api";
import utils from "@/utils";
import storeFunc from "@/utils/storeFunc";
import { isNumber } from 'lodash'

export default {
  name: "ViewItemInfo",
  // eslint-disable-next-line vue/no-unused-components
  components: { swiper, swiperSlide, ImgHoverZoom, VueScroll },
  props: {
    scope: {
      type: String,
      default: "detail",
      validator(value) {
        return ["list", "detail", "cart"].indexOf(value) != -1;
      },
    },
    id: {
      type: [Number, String],
      validator(value) {
        if (value && isNaN(value)) return false;
        return true;
      },
    },
    color: {
      type: [Number, String],
      validator(value) {
        if (value && isNaN(value)) return false;
        return true;
      },
    },
    size: {
      type: [Number, String],
    },
    count: {
      type: [Number, String],
      validator(value) {
        if (value && isNaN(value)) return false;
        return true;
      },
    },
    source: Object,
    confirmText: {
      type: String,
      default: "加入购物车",
    },
  },
  data() {
    return {
      info: null,
      swiperOption: {
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".icon-right-arrow",
          prevEl: ".icon-left-arrow",
        },
      },
      xSwiper: {},
      selectedColor: {},
      selectedSize: {},
      quantity: 1,
      showComments: false,
      comments: [],
      comment: { productRating: 0, logisticsRating: 0 },
      detailTab: 'mp_description',
      detailBrandService: [
        '配送时间：发货日1-3个工作日，以上配送时间不适用于预定产品',
        '配送方式：顺丰快递（免邮）',
        'Onitsuka Tiger鬼塚虎官方线上店提供”7天无理由退货服务”，退回商品应与签收状态相同，同时随单寄回物品 (如有防尘袋、配件、赠品、购物清单、发票等) 也应一同寄回，避免影响您的正常退款',
      ],
      //限购数目列表 key是skc的style
      limitationDict: {}
    };
  },
  created() {
    if (this.source) {
      this.setValue(this.source);
      this.loadAllComments();
    } else if (this.id && this.color) {
      this.loadItemSource(this.id, this.color, this.loadAllComments);
    } else {
      console.warn("缺少参数");
    }
  },
  methods: {
    isShowOriginalPrice: utils.isShowOriginalPrice,
    isGoodsColorDisabled: storeFunc.isGoodsColorDisabled,
    loadItemSource(id, color, callback) {
      api[types.GET_DETAIL](id, color)
        .then((res) => {
          if (res?.code == 1) {
            this.setValue(res.data);
            typeof callback == "function" && callback();
          } else {
            console.warn("[ViewItemInfo@loadItemSource]: ", res);
          }
        })
        .catch((err) => {
          console.warn("[ViewItemInfo@loadItemSource]: ", err);
        });
    },
    setValue(source) {
      let info = source;
      if (Array.isArray(info.colors) && info.colors.length) {
        let lastColorId = this.selectedColor?.id || this.color;
        // eslint-disable-next-line no-useless-escape
        if (/^\/detail\/\d+\-\d+$/.test(this.$route.fullPath)) {
          lastColorId = this.$route.params.id.split("-")[1];
        }
        if (lastColorId) {
          let ret = info.colors.find((item) => item.id == lastColorId);
          this.selectedColor = ret || info.colors[0];
        } else {
          this.selectedColor = info.colors[0];
        }
        this.onQueryColorLimit(this.selectedColor)
      } else {
        console.warn("商品信息缺少颜色数据");
      }
      if (Array.isArray(info.sizes) && info.sizes.length) {
        let lastSizeId = this.selectedSize?.id || this.size;
        if (lastSizeId) {
          let ret = info.sizes.find((sizeItem) => sizeItem.id == lastSizeId);
          this.selectedSize = ret || info.sizes[0];
        } else {
          this.selectedSize = info.sizes[0];
        }
      } else {
        console.warn("商品信息缺少尺码数据");
      }
      this.quantity = this.count || 1;
      this.info = info;
      //
      this.$nextTick(() => {
        this.xSwiper = this.$refs?.xSwiper?.swiper;
      });
      //
      this.gaTrack4ViewItem();
      if (this.selectedColor.mp_description) {
        this.detailTab = 'mp_description'
      } else {
        this.detailTab = 'brand_service'
      }
    },
    //
    gaTrack4ViewItem() {
      if (window.gtag) {
        window.gtag("event", "view_item", {
          send_to: process.env?.VUE_APP_GA4,
          currency: "RMB",
          value: Number(this.info.price),
          items: [
            {
              item_id: `${this.info.id}-${this.selectedColor?.id}`,
              item_name: this.info.name,
              item_brand: "Onitsuka Tiger",
              item_category: this.info.category.name,
              item_variant: this.selectedColor?.name,
              quantity: 1,
              price: Number(this.info.price),
            },
          ],
        });
      }
    },
    // 加载评论数据
    loadAllComments() {
      return;
      //不需要评论
      // if (this.scope == "detail") {
      //   api[types.GET_COMMENTS]({ id: this.id || this.source.id })
      //     .then((res) => {
      //       if (res?.code == 1) {
      //         this.comments = res.data;
      //       } else {
      //         console.warn("[ViewItemInfo@loadAllComments]: ", res);
      //       }
      //     })
      //     .catch((err) => {
      //       console.warn("[ViewItemInfo@loadAllComments]: ", err);
      //     });
      // }
    },
    // 前后切换Slider
    toSlider(offset) {
      if (offset == -1) {
        this.xSwiper?.slidePrev();
      } else {
        this.xSwiper?.slideNext();
      }
    },
    // 切换到指定下标的Slider
    goSlider(index) {
      this.xSwiper?.slideTo(index);
    },
    // 设置颜色：编辑商品SKU
    setColor(color) {
      //会刷新不需要onQueryColorLimit
      this.selectedColor = color;
      //
      this.$emit("change", { type: "color", value: color });
      // eslint-disable-next-line no-useless-escape
      if (/^\/detail\/\d+\-\d+$/.test(this.$route.fullPath)) {
        this.$router.push({
          path: `/detail/${this.info.id}-${this.selectedColor.id}`,
        });
      } else {
        this.loadItemSource(this.info.id, this.selectedColor.id);
      }
    },
    // 设置尺寸：编辑商品SKU
    setSize(size) {
      this.selectedSize = size;
      this.quantity = 1;
      this.$emit("change", { type: "size", value: size });
      this.$emit("change", { type: "quantity", value: 1 });
    },
    // 通知设置
    notify() {
      this.$emit("notify", this.info);
    },
    // 确定操作
    confirm() {
      this.$emit("confirm", {
        info: this.info,
        color: this.selectedColor,
        size: this.selectedSize,
        quantity: this.quantity,
      });
    },
    // 立即购买
    buyNow() {
      this.$emit("checkout", {
        id: this.info.id,
        color: this.selectedColor,
        size: this.selectedSize,
        quantity: this.quantity,
      });
    },
    changeQuantity(evt) {
      let dom = evt.target || evt.srcElement;
      this.$emit("change", { type: "quantity", value: dom.value });
    },
    // 设置评论项星际
    setRating(field, rating) {
      this.comment[field] = rating;
    },
    // 添加平路
    addComment() {
      let args = this.$route.params.id.split("-");
      api[types.ADD_COMMENT]({ id: args[0], color: args[1], ...this.comment })
        .then((res) => {
          if (res?.code == 1) {
            this.info.allowComments = false;
            let {
              username,
              product_rating: productRating,
              logistics_rating: logisticsRating,
            } = res.data;
            let min = Math.min(productRating, logisticsRating);
            if (min < 4) {
              this.$message({ message: "您的评论已提交，正在审核中" });
            } else {
              this.comments.unshift({
                username,
                productRating,
                logisticsRating,
              });
            }
            this.comment = null;
          } else {
            console.warn("[ViewItemInfo@addComment]: ", res);
          }
        })
        .catch((err) => {
          console.warn("[ViewItemInfo@addComment]: ", err);
        });
    },
    copyLabel(value) {
      if (utils.isMobile()) {
        // 创建一个临时的textarea元素
        const textarea = document.createElement('textarea');
        textarea.value = value;
        // 将textarea元素添加到DOM中
        document.body.appendChild(textarea);
        // 选中文本
        textarea.select();
        // 执行复制命令
        document.execCommand('copy');
        // 移除临时的textarea元素
        document.body.removeChild(textarea);
        this.$message({ message: "复制成功", })
      } else {
        // 复制文本到剪贴板的逻辑，可以使用相应的库或者原生API
        const textToCopy = typeof value === 'string' ? value : value.toString();
        navigator.clipboard.writeText(textToCopy)
          .then(() => {
            this.$message({ message: "复制成功", })
          })
          .catch(() => {
            this.$message({ message: "复制失败", type: 'error' })
          });
      }
    },
    onQueryColorLimit(selectedColor) {
      if (selectedColor?.style) {
        api[types.GET_PRODUCT_LIMIT]({ style_number: [selectedColor?.style] })
          .then((res) => {
            if (res?.code == 1) {
              this.limitationDict = { ...this.limitationDict, ...res?.data }
            } else {
              console.warn("[ViewItemInfo@GET_PRODUCT_LIMIT]: ", res);
            }
          })
          .catch((err) => {
            console.warn("[ViewItemInfo@GET_PRODUCT_LIMIT]: ", err);
          });
      }
    },
  },
  watch: {
    source() {
      this.setValue(this.source);
      //切换商品时切到第一帧
      this.xSwiper.slideTo(0, 0)
    },
  },
  computed: {
    colorLimit() {
      let colorItem = this.selectedColor;
      let limitationDict = this.limitationDict;
      if (!colorItem?.style || !limitationDict) {
        return null
      }
      let limit = limitationDict[colorItem?.style]
      return isNumber(limit) ? limit : null
    },
    isColorLimitNumber() {
      return isNumber(this.colorLimit);
    },
    itemCounterMax() {
      const maxStock = 6; // SKU 最多购买六件
      const limitQty = isNumber(this.colorLimit) ? this.colorLimit : Infinity;
      //最小购买1件-老逻辑
      return Math.max(1, Math.min(maxStock, this.selectedSize?.stock || 0, limitQty));
    },
    calcIsShowCustomerTag() {
      return this.$store.state.isShowCustomerTag && this.info?.custom_tags;
    }
  }
};
</script>

<style lang="scss" scoped>
.item-wrapper {
  box-sizing: border-box;
  width: 100%;
  display: flex;

  .item-tags {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    margin-bottom: 15px;

    .logo {
      height: 36px;
      width: auto;

      &.designer-logo {
        height: 12px;
      }
    }

    .item-tag {
      color: #212322;
      /* 中文正文/Text-Small-12-R */
      font-family: Noto Sans CJK SC;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      /* 150% */
      padding: 0 5px;
      border: 1px solid #212322;
      background: #fff;
    }
  }

  .item-extra-mobile {
    display: none;
    box-sizing: border-box;
    position: relative;
    text-align: left;

    .pdp-item-name {
      // font-size: calc(1.625rem * 1.6);
      // line-height: calc(1.625rem * 1.6);
      font-family: "MatterSQ Bold", "NotoSansCJKsc Bold", "FZLanTingHeiS-R-GB",
        Arial, sans-serif;
      font-size: 20px;
      line-height: 28px;
      font-weight: 400;
      letter-spacing: 0.05em;
      margin: 0;
      padding-bottom: 0;
      color: #000;

      .star-style {
        color: #c0010b;
      }
    }

    .pdp-item-extra {
      margin-top: 10px;

      &::after {
        content: "";
        display: table;
        clear: both;
      }

      .pdp-item-classification {
        font-size: calc(0.6875rem * 1.6);
        letter-spacing: 0.025em;
        margin-bottom: 5px;
        color: #666;
        width: 49%;
        display: inline-block;
        text-transform: none;
        text-align: left;
      }

      .pdp-item-number {
        font-size: calc(0.6875rem * 1.6);
        letter-spacing: 0.025em;
        margin-bottom: 5px;
        color: #666;
        width: 49%;
        text-align: right;
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;

        .icon-copy {
          display: inline-block;
          margin-left: 4px;
          cursor: pointer;
        }
      }

      .pdp-item-view {
        margin-bottom: 10px;

        .pdp-item-link {
          font-size: calc(0.75rem * 1.6);
          line-height: 1.5;
          font-weight: 400;
          letter-spacing: 0.025em;
          color: #333;
          text-decoration: underline;

          &:hover {
            font-weight: 400;
          }
        }
      }

      .pdp-item-price {
        margin-bottom: calc(0.3125rem * 1.6);
        color: #000;
        display: inline-block;
        font-weight: 400;
        font-size: calc(1.125rem * 1.6);

        &.has-original_price {
          color: #212322;
          font-weight: 700;
          height: 24px;
          line-height: 24px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          &>span {
            display: inline-block;
          }

          .pdp-original_price {
            margin-left: 8px;
            color: #4d4d4c;
            font-weight: 400;
            text-decoration: line-through;
          }

          .pdp-tag {
            font-size: 12px;
            color: #000;
            font-weight: 400;
            line-height: 1;
            padding: 4px 8px;
            border: 1px solid #000;
            margin-left: 8px;
          }
        }
      }
    }
  }

  .item-images {
    box-sizing: border-box;
    position: relative;
    width: calc(50% - 10px);
    padding: 20px 20px 36px;
    border: 1px solid #b4b5b4;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: normal;
    position: relative;

    .pdp-image-swiper {
      display: flex;
      justify-content: center;
      align-items: center;

      // min-height: 68%;
      .iconfont {
        font-weight: 400;
        cursor: pointer;

        &.disabled {
          color: #efefef;
        }
      }

      .pdp-image-swiper-wrapper {
        width: 100%;
        margin: 0 auto;

        .pdp-item-image-item {
          width: 100%;
          height: auto;
        }

        .swiper-pagination {
          display: none;
        }

        .icon-left-arrow,
        .icon-right-arrow {
          font-size: 28px;
          position: absolute;
          top: 50%;
          z-index: 1;
          transform: translate(0, -50%);

          &.swiper-button-disabled {
            color: #efefef;
          }
        }

        .icon-left-arrow {
          left: 0;
        }

        .icon-right-arrow {
          right: 0;
        }
      }
    }

    .pdp-image-thumbnail {
      margin-top: 20px;

      ul {
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        li {
          box-sizing: border-box;
          width: 80px;
          height: 80px;
          border: 1px solid #b4b5b4;
          margin: 4.5px;
          display: inline-block;

          a {
            display: block;
            padding: 5px 4px 0;
            margin: 0 1px 1px;
            margin-bottom: 1px;
            border-bottom: 2px solid transparent;

            &.active {
              border-bottom: 2px solid #7f0019;
            }

            img {
              max-width: 100%;
              height: auto;
              cursor: pointer;
              display: block;
              margin: 0 auto 2px;
            }
          }
        }
      }
    }
  }

  .item-detail {
    box-sizing: border-box;
    position: relative;
    width: calc(50% - 10px);
    padding: 15px;
    margin-left: 20px;
    border: 1px solid #b4b5b4;
    background: #fff;
    text-align: left;

    .pdp-item-name {
      // font-size: calc(1.625rem * 1.6);
      // line-height: calc(1.625rem * 1.6);
      font-family: "MatterSQ Bold", "NotoSansCJKsc Bold", "FZLanTingHeiS-R-GB",
        Arial, sans-serif;
      font-size: 20px;
      line-height: 28px;
      font-weight: 400;
      letter-spacing: 0.05em;
      margin: 0;
      padding-bottom: 0;
      color: #000;

      .star-style {
        color: #c0010b;
      }
    }

    .pdp-item-extra {
      margin-top: 10px;

      &::after {
        content: "";
        display: table;
        clear: both;
      }

      .pdp-item-classification {
        font-size: calc(0.6875rem * 1.6);
        letter-spacing: 0.025em;
        margin-bottom: 5px;
        color: #666;
        width: 49%;
        display: inline-block;
        text-transform: none;
        text-align: left;
      }

      .pdp-item-number {
        font-size: calc(0.6875rem * 1.6);
        letter-spacing: 0.025em;
        margin-bottom: 5px;
        color: #666;
        width: 49%;
        text-align: right;
        display: inline-flex;
        justify-content: flex-end;
        align-items: center;

        .icon-copy {
          display: inline-block;
          margin-left: 4px;
          cursor: pointer;
        }
      }

      .pdp-item-view {
        margin-bottom: 10px;

        .pdp-item-link {
          font-size: calc(0.75rem * 1.6);
          line-height: 1.5;
          font-weight: 400;
          letter-spacing: 0.025em;
          color: #333;
          text-decoration: underline;

          &:hover {
            font-weight: 400;
          }
        }
      }

      .pdp-item-price {
        margin-bottom: calc(0.3125rem * 1.6);
        color: #000;
        display: inline-block;
        font-weight: 700;
        font-size: calc(1.125rem * 1.6);
        margin-top: 4px;

        &.has-original_price {
          color: #212322;
          font-weight: 700;
          height: 24px;
          line-height: 24px;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          &>span {
            display: inline-block;
          }

          .pdp-original_price {
            margin-left: 8px;
            color: #4d4d4c;
            font-weight: 400;
            text-decoration: line-through;
          }

        }
      }
    }

    .pdp-item-skus {
      border-top: 1px solid #b4b5b4;
      position: relative;
      padding-top: calc(0.5625rem * 1.6);
      margin-top: 5px;

      .pdp-item-sku-options {
        .pdp-item-sku-option {
          box-sizing: border-box;
          margin: 0 0 20px;
          padding: 0;
          border: 0;
          width: 100%;
          float: none;
          font-weight: 400;
          font-size: calc(0.875rem * 1.6);
          line-height: calc(1.5rem * 1.6);

          &.pdp-item-sku-option {
            padding: 2px 0;
          }

          .pdp-item-sku-header {
            font-size: calc(0.875rem * 1.6);
            font-weight: 700;
            line-height: calc(1rem * 1.6);
            margin: 0 0 5px;
            color: #000;
            text-align: left;

            .pdp-item-sku-colors {
              margin-left: 5px;
              font-weight: 400;
              text-transform: none;
              font-size: calc(0.875rem * 1.6);
            }

            .pdp-size-guide {
              line-height: 1.5rem;
              float: right;
              font-weight: 400;
              // font-size: 0.75rem;
              font-size: 12px;
              margin-bottom: 10px;
              color: #000;
              text-transform: capitalize;
              text-decoration: underline;
            }
          }

          .pdp-item-sku-color-list {
            clear: both;
            overflow: auto;
            padding: 0;
            list-style: none;
            margin-top: 8px;

            // &::after { clear: both; content: ''; }
            .pdp-item-sku-color-item {
              width: 20%;
              max-width: 60px;
              line-height: 0;
              font-weight: 700;
              font-size: 0.875rem;
              float: left;
              box-sizing: border-box;
              margin: 0;
              padding: 10px;
              cursor: pointer;
              position: relative;

              img {
                width: 100%;
                height: auto;
              }

              &.active {
                box-shadow: inset 0 0 0 2px #000;
              }

              &.disabled::before {
                content: "";
                width: 80%;
                left: 10%;
                position: absolute;
                background: #4c4c4d;
                height: 1px;
                z-index: 2;
                top: 50%;
              }

              &.disabled::after {
                content: "";
                position: absolute;
                top: 2px;
                bottom: 2px;
                right: 2px;
                left: 2px;
                z-index: 1;
                background: hsla(0, 0%, 100%, 0.7);
              }
            }
          }

          .pdp-item-sku-size-list {
            clear: both;
            overflow: auto;
            padding: 0;
            list-style: none;
            border-left: 1px solid #4d4d4c;
            display: flex;
            flex-wrap: wrap;

            .pdp-item-sku-size-item {
              font-weight: 400;
              // font-size: calc(0.875rem * 1.6);
              font-size: 12px;
              // float: left;
              box-sizing: border-box;
              margin: 0;
              border-bottom: 1px solid #4d4d4c;
              border-right: 1px solid #4d4d4c;
              width: 14.28%;
              line-height: calc(1.5rem * 1.6);

              &:nth-child(-n + 7) {
                border-top: 1px solid #4d4d4c;
              }

              a {
                position: relative;
                display: block;
                padding: 10px;
                color: #000;
                text-decoration: none;
                text-align: center;
                text-transform: uppercase;
                cursor: pointer;
                // font-size: 0.75rem;
                font-size: 12px;
                letter-spacing: 0.025em;
                overflow: hidden;
                font-weight: 400;

                &:hover {
                  color: #000;
                  text-decoration: none;
                  font-weight: 700;
                }

                &.active {
                  font-weight: 700;
                  box-shadow: inset 0 0 0 2px #000;
                }

                &.disabled {
                  color: #666;
                  background-color: #efefef;
                  text-decoration: line-through;
                }

                &.disabled:hover,
                &.active.disabled:hover {
                  font-weight: 400;
                }
              }
            }
          }
        }
      }
    }

    .pdp-item-cart {
      .pdp-item-notify {
        font-weight: 400;
        font-size: calc(0.75rem * 1.6);
        line-height: 1.75em;
        display: inline-block;
        margin-bottom: 10px;
        color: #000;
        text-transform: capitalize;
        text-decoration: underline;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #7F0019;

        .icon-notify {
          display: inline-block;
          margin-right: 6px;
        }
      }

      .pdp-item-stock {
        font-weight: 400;
        // font-size: 0.75rem;
        font-size: 12px;
        margin: 0 0 15px;

        &.invalid {
          color: #bd0025;
        }
      }

      .pdp-item-quantity-label {
        text-align: left;
        text-transform: uppercase;
        width: auto;
        font-size: calc(0.875rem * 1.6);
        letter-spacing: 0.025em;
        display: block;
        margin-bottom: 5px;
        color: #000;

        .limit-text {
          color: #E61545;
          margin-left: 16px;
        }
      }

      .pdp-item-cart-box {
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -ms-flex-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;

        .pdp-item-quantity-wrapper {
          width: 17%;
          overflow: hidden;
          display: block;
          padding-right: 31px;
          box-sizing: border-box;
          border: 1px solid #b4b5b4;
          border-radius: 2px;
          background: #fff url(../assets/imgs/icons/onitsukatiger-drop-down-arrow.svg) no-repeat scroll;
          background-position: right 10px center;
          position: relative;

          select {
            background: transparent;
            padding: 2px 0 2px 10px;
            height: 38px;
            width: 120%;
            width: calc(100% + 31px);
            border: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
          }

          select::-ms-expand {
            display: none;
          }
        }

        .pdp-item-cart-add {
          cursor: pointer;
          display: inline-block;
          box-sizing: border-box;
          line-height: 38px;
          padding: 0 30px;
          font-weight: 400;
          font-size: calc(1rem * 1.6);
          letter-spacing: normal;
          border-radius: 2px;
          text-align: center;
          text-decoration: none;
          text-transform: uppercase;
          transition: all 0.3s ease;
          color: #fff;
          background-color: #7f0019;
          border: 1px solid #7f0019;

          &[disabled] {
            opacity: 0.3;
            cursor: not-allowed;
          }
        }
      }
    }

    .pdp-item-listing-date {
      margin-top: 12px;
      display: flex;
      align-items: center;

      span {
        font-size: calc(0.75rem * 1.6);
        line-height: calc(1rem * 1.6);
      }
    }

    .pdp-item-help-link {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: baseline;
      margin-top: 6px;

      h3 {
        font-weight: 400;
        font-size: calc(0.75rem * 1.6);
        line-height: calc(1.75rem * 1.6);
        margin-top: 0;
        text-transform: uppercase;
      }

      .pdp-item-help-tips {
        font-weight: 400;
        font-size: calc(0.75rem * 1.6);
        letter-spacing: 0.025em;
        display: -ms-inline-flexbox;
        display: -webkit-inline-flex;
        display: inline-flex;
        color: #666;
        cursor: pointer;

        &:hover {
          font-weight: 400;
          text-decoration: underline;
        }
      }
    }

    .comment__wrap {
      border-top: 1px solid #d8d8d8;
      border-bottom: 1px solid #d8d8d8;
      margin-top: 10px;

      .comment__header {
        height: 50px;
        line-height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .comment__title {
          font-size: 14px;
          color: #1d1d1d;
          font-weight: 700;
        }

        .iconfont {
          width: 50px;
          text-align: center;
          cursor: pointer;
          user-select: none;
        }
      }

      .comment__list {
        height: 178px;

        .comment__item {
          padding: 15px 0;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          border-bottom: 1px solid #f1f1f1;

          &:first-child {
            padding-top: 0;
          }

          &:last-child {
            border-bottom: none;
          }

          .comment__author {
            font-size: 12px;
            color: #222;
            font-weight: 700;
            line-height: 17px;
          }

          .comment__info {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 8px;

            .comment__field {
              &:nth-child(2) {
                margin-left: 25px;
              }

              .comment__field--name {
                font-size: 12px;
                color: #666;
                line-height: 17px;
              }

              .comment__field--stars {
                margin-left: 12px;

                .star {
                  margin-right: 6px;
                  user-select: none;
                }
              }
            }
          }

          //
          &.comment__insert {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-end;

            .comment__info {
              flex-direction: column;

              .comment__field {
                &:nth-child(2) {
                  margin-left: 0;
                  margin-top: 20px;
                }

                .comment__field--stars .star {
                  margin-right: 12px;
                  cursor: pointer;
                }
              }
            }

            .comment__action {
              button {
                width: 54px;
                height: 26px;
                font-size: 12px;
                background: #ffffff;
                border: 1px solid #f1f1f1;
                cursor: pointer;
              }
            }
          }
        }

        .comment__empty__msg {
          text-align: center;
        }
      }
    }

    ::v-deep .pdp-item-tabs {

      .el-tabs__active-bar {
        background-color: #212322;
      }

      .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 200%;
        height: 1px;
        background-color: #ADADAD;
        z-index: 1;
        transform: scale(0.5);
        transform-origin: 0 0;
      }

      .el-tabs__item {
        padding: 32px 16px 12px;
        height: 64px;
        box-sizing: border-box;
        color: #666;
        font-family: Matter, Noto Sans CJK SC;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;

        &.is-top:nth-child(2) {
          padding-left: 0;
        }

        &.is-top:last-child {
          padding-right: 0;
        }

        &.is-active {
          color: #212322;
        }

      }

      .detail-ul-item {
        font-family: Matter, Noto Sans CJK SC;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        color: #212322;
        margin-top: 10px;
        display: flex;
        align-items: flex-start;

        &:first-child {
          margin-top: 0;
        }

        &::before {
          flex-shrink: 0;
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #212322;
          margin-top: 8px;
          margin-right: 8px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .item-wrapper {
    .item-images {
      .pdp-image-thumbnail {
        ul {
          text-align: center;

          li {
            width: 65px;
            height: 65px;
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) {
  .dialog-container {

    //对话框里的设置最高值
    //pdp不可以设置
    .item-wrapper {

      .item-images,
      .item-detail {
        overflow-y: auto;
        max-height: 80vh;
      }
    }
  }

  ::v-deep .pdp-item-tabs {

    .el-tabs__content {
      max-height: 120px;
      overflow-y: auto;

      &::-webkit-scrollbar {
        width: 2px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #888;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #555;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .item-wrapper {
    flex-direction: column;

    .item-extra-mobile {
      display: block;
    }

    .item-images {
      box-sizing: border-box;
      width: 100%;
      padding: 0 15px;
      border: none;

      .pdp-image-swiper {
        .pdp-image-swiper-wrapper {
          .swiper-pagination {
            display: block;
          }

          .swiper-pagination-bullets {
            bottom: 0;
          }

          .icon-left-arrow,
          .icon-right-arrow {
            font-size: 24px;
          }
        }
      }

      .pdp-image-thumbnail {
        display: none;
      }
    }

    .item-detail {
      box-sizing: border-box;
      width: 100%;
      margin-left: 0;
      border: none;

      .item-tags {
        display: none;
      }

      .pdp-item-name {
        display: none;
      }

      .pdp-item-extra {
        display: none;
      }

      .pdp-item-skus {
        border-top: none;
      }
    }
  }
}

@media only screen and (max-width: 320px) {
  .item-wrapper {
    .item-detail {
      .pdp-item-skus {
        .pdp-item-sku-options {
          .pdp-item-sku-option {
            .pdp-item-sku-size-list {
              .pdp-item-sku-size-item {
                a {
                  padding: 5px;
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
